import {
  EuiButton,
  EuiButtonEmpty,
  EuiFlexGroup,
  EuiFlexItem,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiPanel,
  EuiStat,
} from "@elastic/eui";
import { useWatch } from "react-hook-form";
import NumberFormat from "react-number-format";

import ACVEstimator, { RCEstimatorFormProvider } from "./ACVEstimator";
import { ACVEInput } from "./ACVEstimator.types";
import { reportEstimate } from "./calculator";

const ACVEstimatorModal = ({
  isModalVisible,
  onSubmit,
  onClose,
  defaultValues,
}: {
  isModalVisible: boolean;
  onSubmit: any;
  onClose: any;
  defaultValues: any;
}) => {
  if (!isModalVisible) return null;

  return (
    <RCEstimatorFormProvider defaultInputValues={defaultValues}>
      <EuiModal aria-labelledby="ACV Modal" onClose={onClose} maxWidth={900}>
        <EuiModalHeader>
          <EuiModalHeaderTitle>
            <h1>Actual Cash Value Estimator</h1>
          </EuiModalHeaderTitle>
        </EuiModalHeader>

        <EuiModalBody>
          <EuiFlexGroup direction="row" responsive={true} alignItems="flexStart">
            <EuiFlexItem>
              <ACVEstimator onFinishEstimator={onSubmit} />
            </EuiFlexItem>

            <EuiFlexItem grow={false} style={{ minWidth: 260 }}>
              <EuiPanel hasBorder color="subdued">
                <ACVResults />
              </EuiPanel>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiModalBody>
        <EuiModalFooter>
          <EuiButtonEmpty onClick={onClose}>Close</EuiButtonEmpty>
          <EuiButton type="submit" form="acvestimator">
            Save
          </EuiButton>
        </EuiModalFooter>
      </EuiModal>
    </RCEstimatorFormProvider>
  );
};
export default ACVEstimatorModal;

const ACVResults = () => {
  const watch = useWatch() as unknown as ACVEInput;

  const data = reportEstimate(watch);
  const { acv, debrisRemovalEstimate, totalCoverageALimit } = data;

  return (
    <>
      <EuiFlexGroup direction="column">
        <EuiFlexItem grow={false}>
          <EuiStat
            title={<NumberFormat value={acv} displayType={"text"} thousandSeparator={true} prefix={"$"} />}
            titleColor="success"
            description="Estimated Actual Cash Value"
            textAlign="right"
            isLoading={data! === undefined}
          />
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiStat
            title={
              <NumberFormat value={debrisRemovalEstimate} displayType={"text"} thousandSeparator={true} prefix={"$"} />
            }
            titleColor="success"
            description="Debris Removal Estimate"
            textAlign="right"
            isLoading={data! === undefined}
          />
        </EuiFlexItem>

        <EuiFlexItem grow={false}>
          <EuiStat
            title={
              <NumberFormat value={totalCoverageALimit} displayType={"text"} thousandSeparator={true} prefix={"$"} />
            }
            titleColor="success"
            description="Max Coverage A Limit"
            textAlign="right"
            isLoading={data! === undefined}
          />
        </EuiFlexItem>
      </EuiFlexGroup>
    </>
  );
};
